export default __webpack_public_path__ + "static/media/up_Arrow.0c7c6942.svg";